import RatingTile from "../RatingTile/RatingTile";
import "./ThermalRatingTile.scss";

interface ThermalRatingTileProps {
	score: number | null | undefined;
}

const thermalRatingScores = [1, 2, 3, 4, 5];

export default function ThermalRatingTile({ score }: ThermalRatingTileProps) {
	if (score == null || !thermalRatingScores.includes(score)) return <></>;

	return (
		<RatingTile className="thermal-rating-tile" data-score={score}>
			{score}
		</RatingTile>
	);
}
